<template>
	<div class="pick-up-add-row">
		<van-form @submit="submit">
			<div class="pick-up-add-card">
				<van-field
					v-model="form.name"
					label-class="form-label"
					label="收货人"
					input-align="right"
					placeholder="请输入收货人姓名"
					maxlength="30"
					:rules="[{ required: true }]"
				/>
				<van-field
					v-model="form.phone"
					label-class="form-label"
					label="手机号码"
					input-align="right"
					placeholder="请输入手机号"
					type="number"
					:maxlength="11"
					:rules="[{ required: true }]"
				/>
				<van-field
					:value="city"
					label-class="form-label"
					label="所在地区"
					input-align="right"
					placeholder="选择省、市、区"
					readonly
					is-link
					:rules="[{ required: true }]"
					@click="show = true"
				/>
				<van-field
					v-model="form.address"
					label-class="form-label"
					label="详细地址"
					input-align="right"
					placeholder="楼号、楼层、门牌号"
					:rules="[{ required: true }]"
					maxlength="50"
				/>
			</div>
			<div class="pick-up-add-card" style="margin-top:3.733vw;">
				<van-cell title="默认地址" label="每次下单会默认推荐使用该地址">
					<template #right-icon>
						<van-switch
							:active-value="1"
							:inactive-value="0"
							v-model="form.defaultAddress"
							active-color="#00BCD1"
							inactive-color="#EAEAEA"
						/>
					</template>
				</van-cell>
			</div>
			<foot-button>
				<van-button type="primary" block native-type="submit">保存</van-button>
			</foot-button>
		</van-form>
		<van-popup v-model="show" round position="bottom">
			<van-cascader
				:value="cascaderValue"
				title="所在地区"
				:options="options"
				@close="show = false"
				@finish="onFinish"
				active-color="#00BCD1"
				:field-names="fieldNames"
			/>
		</van-popup>
	</div>
</template>

<script>
	export default {
	    data() {
	        return {
				takeLeave: false,
	            form: {
	                name: "",
	                phone: "",
	                provinceId:'',
	                province:'',
	                cityId:'',
	                city:'',
	                areaId:'',
	                area:'',
	                address:'',
	                defaultAddress:0,
	            },
	            fieldNames: {
	                text: 'name',
	                value: 'id',
	                children: 'child',
	            },
	            options:[],
	            show: false,
	        };
	    },
		beforeRouteLeave (to, from, next) {
			if (this.takeLeave) {
				next()
			} else {
				this.takeLeave = true
				const isEditForm = Object.values(this.form).some(item => !!item)
				if (isEditForm) {
					this.$dialog.confirm({
						title: '',
						message: '退出后将不保存本次编辑内容，确认退出吗',
						confirmButtonText: '确认退出',
						cancelButtonText: '继续编辑'
					}).then(() => {
						next()
					}).catch(() => {
						this.takeLeave = false
						this.$utils.clearDialog()
						next(false)
					})
				} else {
					next()
				}
			}
		},
	    computed: {
	        patientId() {
	            return this.$store.getters['account/getPatientId']
	        },
	        disabled() {
	            return true;
	        },
	        city(){
	            return this.form.province?`${this.form.province} ${this.form.city} ${this.form.area}` :''
	        },
	        cascaderValue(){
	            return this.form.areaId
	        },
	        addressId(){
	            return this.$route.params.id
	        }

	    },
	    created(){
			this.$utils.clearDialog()
			if (this.$route.params.id) {
				document.title = '修改地址'
			}
	        this.init(this.addressId)
	    },
	    methods: {
	        init(id){
	            this.getRegion()
	            if(id){
	                this.getDetail()
	            }else{
	                this.form = Object.assign(this.$data.form,this.$options.data().form)
					this.getDefaultAddress()
	            }
	        },
			// 检测是否有默认地址
			async getDefaultAddress () {
				const res = await this.$api.address.page({
					page: 1,
					limit: 10,
					patientId: this.$store.getters['account/getPatientId'],
					defaultAddress: 1
				})
				if (!res.code) {
					this.$set(this.form, 'defaultAddress', Number(!res.data.total))
				}
			},
	        getRegion(){
	            this.$api.address.regionTree({}).then(({ data }) => {
	                this.options = data
	            })
	        },
	        submit() {
				if (!this.$reg.isMobile(this.form.phone)) {
					this.$toast('请输入正确的手机号')
					return
				}
				if (!this.form.name.trim()) {
					this.$toast('请输入姓名')
					return
				}
				if (!this.form.phone.trim()) {
					this.$toast('请输入手机号')
					return
				}
				if (!this.form.address.trim()) {
					this.$toast('请输入详细地址')
					return
				}
	            let params = this.form
	            params['patientId'] = this.patientId
	            let func = this.addressId ? this.$api.address.update : this.$api.address.create
	            func(params).then(()=>{
					this.takeLeave = true
	                this.$toast('保存成功')
	                this.$router.go(-1)
	            })
	        },


	        getDetail(){
	            this.$api.address.detail(this.addressId).then(({data})=>{
	                this.form = data
	                // this.getCityList()
	            })

	        },
	        onFinish( {selectedOptions} ){
	            this.show = false

				this.$set(this.form, 'provinceId', selectedOptions[0].id)
				this.$set(this.form, 'province', selectedOptions[0].name)

				this.$set(this.form, 'cityId', selectedOptions[1].id)
				this.$set(this.form, 'city', selectedOptions[1].name)

				this.$set(this.form, 'areaId', selectedOptions[2].id)
				this.$set(this.form, 'area', selectedOptions[2].name)
	        }
	    }
	};
</script>

<style scoped lang="less">
	.pick-up-add-row {
	    min-height: 140vw;
	    padding: 4.2vw;
	    background-color: #f6f7f8;
	}
	.pick-up-add-card {
	    background-color: #ffffff;
	    border-radius: 2.1vw;
	    overflow: hidden;
	    .van-cell{
	        align-items: center;
	        height:14.933vw;
	        font-size: 4vw;
	    }
	    /deep/.van-field__label{
	        color:#1F2329;
	    }

	}
	.yplus-button-row {
	    height: 94px;
	    display: flex;
	}
	.button-fixed {
	    width: 92vw;
	    left: 4vw;
	    position: fixed;
	    bottom: calc(16vw - 44px);
	    height: 44px;
	}
	.delete-toast {
	    color: #60646b;
	    font-size: 3.7vw;
	    padding: 1vw 12vw;
	}
	.address-default {
	    padding: 10px 16px;
	    display: flex;
	    align-items: center;
	    margin-top: 3.7vw;
	}
</style>
